import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";


const GetAllUsers = async (data) => {
    const user = useAuth()
    const url = APIURL + "/admin/viewuser"
    return await axios.post(url, { access_token: user.token, ...data })
}

export default GetAllUsers